import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ProductCreateFoodcostSelectIngPage } from "../product-create-foodcost-select-ing/product-create-foodcost-select-ing";
import { FormBuilder, Validators } from '@angular/forms';
import { Globals } from "../../../../../globals";
import { ProductsServices } from "../../../services";
import { TranslateService } from '@ngx-translate/core';
import { StaticsServices } from '../../../../services/statics';

/**
 * Generated class for the ProductCreateFoodcostInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-foodcost-info',
  templateUrl: 'product-create-foodcost-info.html',
})
export class ProductCreateFoodcostInfoPage {

  product_name: any;
  product_uid: string;
  update_state: boolean = false;
  product: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public productsServices: ProductsServices,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    public staticsServices: StaticsServices) {
    //Params
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      this.productsServices.product_tags = this.navParams.get('tags');
      this.product_uid = this.navParams.get('product_uid');

      var stock_max = 0;
      if (this.navParams.get('stock_max')) {
        stock_max = this.navParams.get('stock_max')
      }

      this.productsServices.form = fb.group({
        name: [this.navParams.get('product_name')],
        name_en: [this.navParams.get('name_en')],
        name_fr: [this.navParams.get('name_fr')],
        name_it: [this.navParams.get('name_it')],
        name_de: [this.navParams.get('name_de')],
        name_ca: [this.navParams.get('name_ca')],
        measurement: [this.navParams.get('measurement')],
        stock: [this.navParams.get('stock')],
        stock_alert: [this.navParams.get('stock_alert')],
        stock_max: [stock_max],
        sub_recipe: [true],
        description_es: [this.navParams.get('description_es')],
        description_en: [this.navParams.get('description_en')],
        description_fr: [this.navParams.get('description_fr')],
        description_it: [this.navParams.get('description_it')],
        description_de: [this.navParams.get('description_de')],
        description_ca: [this.navParams.get('description_ca')],
      });
    } else {
      this.productsServices.product_tags = Array();

      this.productsServices.form = fb.group({
        name: ['', this.returnRequiredByLang('es')],
        name_en: ['', this.returnRequiredByLang('en')],
        name_fr: ['', this.returnRequiredByLang('fr')],
        name_it: ['', this.returnRequiredByLang('it')],
        name_de: ['', this.returnRequiredByLang('de')],
        name_ca: ['', this.returnRequiredByLang('ca')],
        measurement: ['ud.'],
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [true],
        description_es: [''],
        description_en: [''],
        description_fr: [''],
        description_it: [''],
        description_de: [''],
        description_ca: [''],
      });
    }


  }

  returnRequiredByLang(lang) {
    if (this.globals.restaurant.lang == lang) {
      return Validators.compose([Validators.required]);
    } else {
      return '';
    }
  }

  submit() {
    if (this.productsServices.form.valid) {
      // Validar que haya al menos un tag seleccionado
      if (!this.productsServices.product_tags || this.productsServices.product_tags.length === 0) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-introduce-categoria-plato-continuar'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
        return;
      }
      
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-nombre-producto-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  updateDefaultNames() {
    // Detectar el idioma principal del restaurante
    let mainLang = this.globals.restaurant.lang;
    let mainField = mainLang === 'es' ? 'name' : `name_${mainLang}`;
    const mainName = this.productsServices.form.value[mainField];
    if (mainName) {
      const formValue = this.productsServices.form.value;
      if (!formValue.name) formValue.name = mainName;
      if (!formValue.name_en) formValue.name_en = mainName;
      if (!formValue.name_fr) formValue.name_fr = mainName;
      if (!formValue.name_it) formValue.name_it = mainName;
      if (!formValue.name_de) formValue.name_de = mainName;
      if (!formValue.name_ca) formValue.name_ca = mainName;
      this.productsServices.form.patchValue(formValue);
    }
  }

  insert() {
    this.updateDefaultNames();
    this.productsServices.afs.collection('products').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.productsServices.form.value.name,
      'name_en': this.productsServices.form.value.name_en,
      'name_fr': this.productsServices.form.value.name_fr,
      'name_it': this.productsServices.form.value.name_it,
      'name_de': this.productsServices.form.value.name_de,
      'name_ca': this.productsServices.form.value.name_ca,
      'measurement': this.productsServices.form.value.measurement,
      'stock': this.productsServices.form.value.stock,
      'stock_alert': this.productsServices.form.value.stock_alert,
      'stock_max': this.productsServices.form.value.stock_max,
      'sub_recipe': true,
      'tags': this.productsServices.product_tags,
      'tags_static': this.productsServices.product_tags.toString(),
      'price_static': 0,
      'foodcost': Array(),
      'description_es': this.productsServices.form.value.description_es,
      'description_en': this.productsServices.form.value.description_en,
      'description_fr': this.productsServices.form.value.description_fr,
      'description_it': this.productsServices.form.value.description_it,
      'description_de': this.productsServices.form.value.description_de,
      'description_ca': this.productsServices.form.value.description_ca,
      'created_at': new Date(),
      'updated_at': new Date(),

    }).then(doc => {
      // Añadir tags nuevos al array global
      if (this.productsServices.product_tags && this.productsServices.product_tags.length > 0) {
        this.globals.addTagsToGlobal(this.productsServices.product_tags);
      }
      this.globals.GAtrackView('Products', 'Products - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Products', this.productsServices.form.value.name);
      //Get the UID Document
      this.sendData();
      this.productsServices.product_tags = null;
      this.navCtrl.push(ProductCreateFoodcostSelectIngPage, {
        update_state: false,
        product_uid: doc.id,
        product_name: this.productsServices.form.value.name,
        product_measurement: this.productsServices.form.value.measurement
      });
    });
  }

  update() {
    this.productsServices.afs.collection('products').doc(this.product_uid).update({
      'name': this.productsServices.form.value.name,
      'name_en': this.productsServices.form.value.name_en,
      'name_fr': this.productsServices.form.value.name_fr,
      'name_it': this.productsServices.form.value.name_it,
      'name_de': this.productsServices.form.value.name_de,
      'name_ca': this.productsServices.form.value.name_ca,
      'measurement': this.productsServices.form.value.measurement,
      'stock': this.productsServices.form.value.stock,
      'stock_alert': this.productsServices.form.value.stock_alert,
      'stock_max': this.productsServices.form.value.stock_max,
      'tags': this.productsServices.product_tags,
      'tags_static': this.productsServices.product_tags.toString(),
      'sub_recipe': true,
      'description_es': this.productsServices.form.value.description_es,
      'description_en': this.productsServices.form.value.description_en,
      'description_fr': this.productsServices.form.value.description_fr,
      'description_it': this.productsServices.form.value.description_it,
      'description_de': this.productsServices.form.value.description_de,
      'description_ca': this.productsServices.form.value.description_ca,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      // Añadir tags nuevos al array global
      if (this.productsServices.product_tags && this.productsServices.product_tags.length > 0) {
        this.globals.addTagsToGlobal(this.productsServices.product_tags);
      }
      this.globals.GAtrackView('Products', 'Products - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Products', this.productsServices.form.value.name);
      this.sendData();
      this.staticsServices.changeStateStaticWait(true);
      this.navCtrl.pop();
    });
  }

  sendData() {
    for (let value of this.productsServices.product_tags) {
      this.globals.dataSet('product_tag', value, '', this.productsServices.form.value.name);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-info/product-create-foodcost-info.ts